import type { Domain } from '@/entities/domain';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getDomains = (
  params?: RequestMeta,
): Promise<{ domains: Domain[]; meta: ResponseMeta }> =>
  request({
    url: '/domains/',
    params,
  });
